import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';

//* import css
import cssClasses from "./CreateUser.module.css";
import { Box, Typography} from "@mui/material";

//* import sub-component
import CustomInput from "../../../Subcomponents/CustomInput"
import CustomRadio from '../../../Subcomponents/CustomRadio';
import Button from '../../../Subcomponents/Button';
import ConfirmationAlert from '../../../Subcomponents/ConfirmationAlert';
import AddIcon from "@mui/icons-material/Add";

//* import npm
import { useNavigate } from 'react-router-dom';

//* import services
import { UploadCrmUserDoc, authSignUp, deleteCrmUserDoc, getCrmUserDoc, insertUser, updateUser, addUserToBlacklistIfAbsent, deleteBlacklistedPhoneNumber } from '../../../Services/Users';
import { errorTost, successTost } from '../../../Services/Toast';
import { presentLoader, dismissLoader } from '../../../Services/loader';
import JsFileDownloader from "js-file-downloader";

//*import files
import PDFIcon from '../../../Assets/Images/CollateralIcons/PDF.svg';

const AddDetails = forwardRef(({ userObject, setUserObject, onTabChange }, ref) => {

  const isLeaveComponentPromise = useRef(null);
  const navigate = useNavigate();

  const [user, setUser] = useState({
    name: "",
    email: "",
    contactNumber: "",
    isCrmUser: false,
    isCpSourcingUser: false,
    crmUserDocUrl: [],
    crmDesignation : ""
  });
  const [password, setPassword] = useState("");
  const [passwordToggler, setPasswordToggler] = useState("Manual");

  const [fieldHelperText, setFieldHelperText] = useState({
    name: "",
    email: "",
    contactNumber: "",
    password: "",
    crmUserDocUrl: "",
    crmDesignation : ""
  })

  const [confirmationAlertToggler, setConfirmationAlertToggler] = useState(false);


  useEffect(() => {
    let _user = {}
    Object.keys(user).forEach((element) => {
      if (element === "isCrmUser" || element === "isCpSourcingUser") {
        _user[element] = userObject[element] ? true : false;
      } else {
        _user[element] = userObject[element];
      }
      // console.log("_user" , _user);
    })
    setUser(JSON.parse(JSON.stringify({ ..._user })))
  }, [userObject ])

  useEffect(() => {
    console.log(user);
  })


  function isLeaveComponent() {
    return new Promise((resolve, reject) => {
      if (userObject.name === user.name && userObject.email === user.email && userObject.contactNumber === user.contactNumber && userObject.isCrmUser === user.isCrmUser || userObject.crmUserDocUrl.length === user.crmUserDocUrl.length) {
        console.log("userObject--->" , userObject)
        console.log("user---->" , user)
        resolve(true);
      } else {
        console.log("userObject---<" , userObject)
        console.log("user----<" , user)
        setConfirmationAlertToggler(true);
        isLeaveComponentPromise.current = resolve;
      }
    })
  }

  useImperativeHandle(ref, () => ({
    isLeaveComponent
  }));

  function autoGeneratePassword() {
    // var chars = "0123456789abcdefghijklmnopqrstuvwxyz@ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    // var passwordLength = 10;
    // var password = "";
    // for (var i = 0; i <= passwordLength; i++) {
    //   var randomNumber = Math.floor(Math.random() * chars.length);
    //   password += chars.substring(randomNumber, randomNumber + 1);
    // }
    // setPassword(password);
    const password = createPassword();
    setPassword(password);
  }
  function createPassword() {
    const numberChars = '0123456789';
    const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
    const allChars = numberChars + upperChars + lowerChars;
    let randPasswordArray = Array(10);
    randPasswordArray[0] = numberChars;
    randPasswordArray[1] = upperChars;
    randPasswordArray[2] = lowerChars;
    randPasswordArray = randPasswordArray.fill(allChars, 3);
    return shuffleArray(randPasswordArray.map(function (x) { return x[Math.floor(Math.random() * x.length)]; })).join('');
  }
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  async function onClickSaveDetails() {

    let isValidArray = [
      {
        fieldName: "name",
        isValid: isRequiredFieldValid(user.name, "name", 3, null),
      },
      {
        fieldName: "email",
        isValid: isEmailValid(user.email),
      },
      {
        fieldName: "contactNumber",
        isValid: isPhoneNumberValid(user.contactNumber),
      },
      {
        fieldName: "crmDesignation",
        isValid: user.isCrmUser ? isRequiredFieldValid(user.crmDesignation, "crmDesignation", 3, null) : {flag: true, helperText:""},
      }
    ]
    if ((!userObject?.userId || userObject?.userId === "") && passwordToggler === "Manual") {
      isValidArray.push({
        fieldName: "password",
        isValid: isPasswordFieldValid(password),
      });
    }
    if (user?.isCrmUser) {
      let _isValid = {
        flag: true,
        helperText: "",
      }
      if (user?.crmUserDocUrl && user?.crmUserDocUrl?.length === 0) {
        _isValid.flag = false;
        _isValid.helperText = "Please upload documents.";
      }
      isValidArray.push({
        fieldName: "crmUserDocUrl",
        isValid: _isValid,
      });
    }

    if (isValidArray.some(s => !s.isValid.flag)) {
      let obj = {};
      isValidArray.forEach(ele => {
        if (!ele.isValid.flag) {
          obj[ele.fieldName] = ele.isValid.helperText;
        }
      })
      setFieldHelperText({ ...fieldHelperText, ...obj });
      return;
    }

    console.log("%c Validate complete", "color: red");
    console.log(user);

    if (userObject?.userId && userObject?.userId !== "") {
      updateUserToServer();
    } else {
      createUserToServer();
    }
  }

  async function createUserToServer() {
    try {
      presentLoader();
      const authSignUpResponse = await authSignUp({ email: user.email, password });
      if (authSignUpResponse.user) {
       
        let postBody = {
          userId: authSignUpResponse.user.id,
          name: user.name,
          email: user.email,
          isCrmUser : user.isCrmUser,
          isCpSourcingUser: user.isCpSourcingUser === true,
          // crmUserDocUrl :"",
          contactNumber: user.contactNumber,
          completedTabs: ["Add Details"],
          crmDesignation : user.crmDesignation
        }
        console.log("post-Body" , postBody)
        const insertUserResponse = await insertUser(postBody);
        console.log('insert user data', insertUserResponse);
        if (insertUserResponse.data) {
          addUserToBlacklistIfAbsent(insertUserResponse.data.userId, user.contactNumber);
          if(user.isCrmUser) {
            
            let _urlArray = [...userObject.crmUserDocUrl];
            for (const fileItem of user?.crmUserDocUrl) {
              if (typeof fileItem === "object") {

                const UploadCrmUserDocResponse = await UploadCrmUserDoc(fileItem, `${insertUserResponse.data.userId}/${fileItem.name}`);
                console.log("UploadCrmUserDocResponse -> ", UploadCrmUserDocResponse);
                if (UploadCrmUserDocResponse.success) {
                  _urlArray.push(UploadCrmUserDocResponse.url);
                }
                console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
              }
            }
            console.log(_urlArray);
            
            let updatePostBody = {
              crmUserDocUrl: _urlArray,
            }
            const updateUserDocResponse = await updateUser(updatePostBody, insertUserResponse.data.userId);
            if (updateUserDocResponse.data) {
              setUserObject({ ...updateUserDocResponse.data });
            }
          } else {
            setUserObject({ ...insertUserResponse.data });
          }
          setTimeout(() => {
            dismissLoader();
            navigate(`/home/users/createUser?userId=${insertUserResponse.data.userId}&userTab=Assign+Role`);
            successTost("User details added successfully.");
            // onTabChange("Assign Role");
          }, 500);
        } else {
          console.log("error => ", insertUserResponse);
          if (insertUserResponse?.error?.message) {
            errorTost(insertUserResponse.error.message);
          } else {
            errorTost("Something went wrong! Try again");
          }
          dismissLoader();
        }
      } else {
        console.log("error => ", authSignUpResponse);
        if(authSignUpResponse?.error?.message === 'User already registered') {
          errorTost("User with email id already exists")
        } else if (authSignUpResponse?.error?.message) {
          errorTost(authSignUpResponse.error.message);
        } else {
          errorTost("Something went wrong! Try again");
        }
        dismissLoader();
      }
    } catch (error) {
      console.log("Error= -> ", error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }

  async function updateUserToServer() {
    let postBody = {
      name: user.name,
      contactNumber: user.contactNumber,
      isCrmUser : user.isCrmUser,
      isCpSourcingUser: user.isCpSourcingUser === true
    }
    presentLoader();

    //todo -------------------> upload document
    const deletedUrl = userObject.crmUserDocUrl?.filter(f => !user?.crmUserDocUrl?.filter(f1 => typeof f1 === "string")?.some(s => s === f));
    if(postBody?.isCrmUser) {
      let _urlArray = [...userObject.crmUserDocUrl?.filter(f => user?.crmUserDocUrl?.filter(f1 => typeof f1 === "string")?.some(s => s === f))];

      console.log("deletedUrl => ", deletedUrl);
      if(deletedUrl.length > 0) {
        deletedUrl.forEach((ele) => {
          console.log(ele)
          deleteCrmUserDoc(ele.split('/').splice(-2).join('/')).then((resp) => {
            console.log("deleted-successfully!" , resp)
          }).catch((err) => {
            console.error("deleteCrmUserDoc" , err)
          })
        })
      }
      
      for (const fileItem of user?.crmUserDocUrl) {
        if (typeof fileItem === "object") {
          const UploadCrmUserDocResponse = await UploadCrmUserDoc(fileItem, `${userObject?.userId}/${fileItem.name}`);
          console.log("UploadCrmUserDocResponse -> ", UploadCrmUserDocResponse);
          if (UploadCrmUserDocResponse.success) {
            _urlArray.push(UploadCrmUserDocResponse.url);
          }
          console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
        }
      }

      postBody.crmUserDocUrl = _urlArray;
      postBody.crmDesignation = user.crmDesignation;
    }

    const updateUserResponse = await updateUser(postBody, userObject?.userId);
    console.log('update user : ', updateUserResponse)
    if (updateUserResponse.data) {
      setUserObject({ ...updateUserResponse.data });
      if (userObject.contactNumber !== user.contactNumber) {
        deleteBlacklistedPhoneNumber(userObject.contactNumber);
        addUserToBlacklistIfAbsent(userObject.userId, user.contactNumber);
      }
      successTost("User details updated successfully.");
      dismissLoader();
      onTabChange("Assign Role");
    } else {
      if (updateUserResponse?.error?.message) {
        errorTost(updateUserResponse?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }
  

  function selectFiles() {
    let htmlElement = document.createElement("input");
    htmlElement.type = "file";
    htmlElement.accept = "application/pdf";
    htmlElement.multiple = true;
    htmlElement.click();
    htmlElement.onchange = onChangeSelectImage;
  }
  function onChangeSelectImage(e) {
    let _files = Object.keys(e.target.files).map((m) => e.target.files[m]);
    // console.log("files.size" , _files.some(s => s.size > 5000000))
    if(!_files.some(s => s.size > 6000000) ) {
      if (!_files.some(s => !s.type.includes("pdf"))) {
        user.crmUserDocUrl = [...user.crmUserDocUrl, ..._files];
        setUser({...user});
      } else {
        errorTost("Please Select only pdf files.");
      }
    
    } else {
      errorTost("Cannot upload as file size is larger than 6MB!")
    }
    
  }


  function DownloadDoc(docItem) {
    if(typeof docItem === 'object') {
      console.log("doc-Item" , docItem)
      presentLoader();
      var fr = new FileReader();
      fr.readAsDataURL(docItem);
      var blob = new Blob([docItem], { type: "application/pdf" });
      var objectURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = objectURL;
      link.download = `${docItem.name}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      successTost("Downloaded SuccessFully!")
      dismissLoader();
    } else {
      console.log("Download-Doc" , docItem.split('/').splice(-3).join('/'))
      presentLoader();
      new JsFileDownloader({
        url: process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + docItem.split('/').splice(-3).join('/'),
      })
        .then(function () {
          dismissLoader();
          successTost("Downloaded SuccessFully!")
          // Called when download ended
        })
        .catch(function (error) {
          console.log(error);
          errorTost("Something went wrong!")
          // Called when an error occurred
        });
    } 
  
   
  }

  function DeleteDoc(docItem, documentIndex) {
    console.log("delete-Doc" , docItem, documentIndex)
    if (typeof user.crmUserDocUrl[documentIndex] === "object") {
      user.crmUserDocUrl.splice(documentIndex, 1);
      setUser({...user});
    } else {
      user.crmUserDocUrl.splice(documentIndex, 1);
      setUser({...user});
    }
  }

  return (
    <>
      <div className={cssClasses.addDetailsForm}>
        <div className={cssClasses.inputWrapper}>
          <label>Full Name <span>*</span></label>
          <CustomInput
            placeholder='Enter full name'
            value={user?.name}
            helperText={fieldHelperText.name}
            handleChange={(_value) => {
              _value = _value.trimStart();
              var alphabet = /^[A-Z*\sa-z]*$/;
              if(_value.match(alphabet)) {
                setUser({ ...user, name: _value });
                let _isValid = isRequiredFieldValid(_value, "full name", 10, null);
                setFieldHelperText({ ...fieldHelperText, name: _isValid.helperText });
              }
             
            
            }}
          />
        </div>

        <div className={cssClasses.emailContactWrapper}>
          <div className={cssClasses.inputWrapper}>
            <label>Email <span>*</span></label>
            <CustomInput
              placeholder='Enter e-mail id'
              value={user?.email}
              helperText={fieldHelperText.email}
              handleChange={(_value) => {
                _value = _value.toLowerCase();
                setUser({ ...user, email: _value });
                let _isValid = isEmailValid(_value);
                setFieldHelperText({ ...fieldHelperText, email: _isValid.helperText });
              }}
              disabled={Boolean(userObject?.userId)}
            />
          </div>
          <div className={cssClasses.inputWrapper}>
            <label>Contact Number <span>*</span></label>
            <CustomInput
              placeholder='Enter contact number'
              value={user?.contactNumber}
              helperText={fieldHelperText.contactNumber}
              handleChange={(_value) => {
                if ((+_value || _value === "") && _value.length <= 12) {
                  setUser({ ...user, contactNumber: _value });
                  let _isValid = isPhoneNumberValid(_value);
                  setFieldHelperText({ ...fieldHelperText, contactNumber: _isValid.helperText });
                }
              }}
            />
          </div>
        </div>
        
        {(!userObject.userId || userObject.userId === "") &&
          <>
            <div className={cssClasses.inputWrapper}>
              <label>Generate Password :</label>
              <CustomRadio
                optionList={["Auto-Generate", "Manual"]}
                onChangeValue={(_value) => {
                  if (_value === "Auto-Generate") {
                    setFieldHelperText({ ...fieldHelperText, password: "" });
                    autoGeneratePassword()
                  } else {
                    setPassword("");
                  }
                  setPasswordToggler(_value);
                }}
                value={passwordToggler}
              />
            </div>
            <div className={cssClasses.inputWrapper}>
              <label>{passwordToggler === "Auto-Generate" ? "Auto Generated Password" : "Password"}  <span>*</span></label>
              <CustomInput
                disabled={passwordToggler === "Auto-Generate"}
                placeholder={passwordToggler === "Auto-Generate" ? "" : "Enter Password Manually"}
                value={password}
                helperText={fieldHelperText.password}
                handleChange={(_value) => {
                  setPassword(_value);
                  let _isValid = isPasswordFieldValid(_value);
                  setFieldHelperText({ ...fieldHelperText, password: _isValid.helperText });
                }}
              />
            </div>
          </>
        }

       <div style={{display : "flex", gap : "2rem"}}>
       <div className={cssClasses.inputWrapper}>
          <label>User Type<span>*</span></label>
          <CustomRadio
            optionList={["Sales", "CRM", "CP Sourcing"]}
            onChangeValue={(_value) => {
              setUser({
                ...user,
                isCrmUser: _value === "CRM",
                isCpSourcingUser: _value === "CP Sourcing",
              });
            }}
            value={user?.isCpSourcingUser ? "CP Sourcing" : user?.isCrmUser ? "CRM" : "Sales"}
          />
        </div>
          {user?.isCrmUser && (
             <div className={cssClasses.inputWrapper}>
             <label>CRM Designation<span>*</span></label>
             <CustomInput
                 placeholder='Enter crm designation'
                 value={user?.crmDesignation}
                 helperText={fieldHelperText.crmDesignation}
                 handleChange={(_value) => {
                  _value = _value.trimStart();
                  var alphabet = /^[A-Z*\sa-z]*$/;
                  if(_value.match(alphabet)) {
                    setUser({ ...user, crmDesignation: _value });
                    let _isValid = isRequiredFieldValid(_value, "crm designation", 5, null);
                    setFieldHelperText({ ...fieldHelperText, crmDesignation: _isValid.helperText });
                  }
                 }}
               />
           </div>
          )}
       </div>
          

        {(user?.isCrmUser) && (
          <div className={cssClasses.inputWrapper}>
            <label>Add Documents <span>*</span></label>
            <Box className={cssClasses.uploadDocumentWrapper}>

              {
                user?.crmUserDocUrl?.map((documentItem, documentIndex) => (
                  <Box key={`document_${documentIndex}`} className={cssClasses.uploadDocumentCard}>
                    <img src={PDFIcon} alt='Pdf' width={"40rem"} height={"40rem"} />
                    <div className={cssClasses.uploadLabel} style={{color:"#000000"}}>
                      <p>{typeof documentItem === "string" ? documentItem?.split("/").pop() : documentItem.name}</p>
                    </div>
                    
                    <div style={{display:"flex" , flexDirection:"row" , gap:"2rem" , marginTop:"1rem"}}>
                    <div onClick={() => DownloadDoc(documentItem)} id="PDF" className={cssClasses.uploadLabel} style={{cursor: "pointer", textDecorationLine: "underline"}}>
                      <p>Download</p>
                    </div>
                    <div onClick={() => DeleteDoc(documentItem, documentIndex)} className={cssClasses.uploadLabel} style={{cursor: "pointer", textDecorationLine: "underline" }}>
                      <p>Delete</p>
                    </div>
                    </div>
                    
                  </Box>
                ))
              }
              
              <Box className={cssClasses.uploadDocumentCard}>
                <div className={cssClasses.uploadLabel} style={{cursor: "pointer", textDecorationLine: "underline"}}>
                  <p onClick={selectFiles}><AddIcon style={{ width: "45px", height: "35px" }} /></p>
                </div>
              </Box>
            </Box>
            {fieldHelperText?.crmUserDocUrl && (
              <p style={{ color: '#d32f2f', fontSize: '1.4rem', marginLeft: '1rem'}}>
                {fieldHelperText?.crmUserDocUrl}
              </p>
            )}
          </div>

        )}
            
      </div>
      <div className={cssClasses.buttonWrapper} style={{ justifyContent: "flex-end" }}>
        <div>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            btnName={"Save Details & Next"}
            clicked={() => {
              onClickSaveDetails();
            }}
            // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
            iconPosition={"left"}
          />
        </div>
      </div>
      <ConfirmationAlert
        open={confirmationAlertToggler}
        title={"Warning"}
        subTitle={"Unsaved Changes! Do you want to continue without saving."}
        confirm={(_value) => {
          console.log(_value);
          if (_value === "rejected") {
            setConfirmationAlertToggler(false);
            isLeaveComponentPromise.current(false);
          } else {
            setConfirmationAlertToggler(false);
            isLeaveComponentPromise.current(true);
          }
        }}
        buttonTitle={"Cancel"}
        returnRespButton={"Continue"}
        close={() => { setConfirmationAlertToggler(false) }}
      />
    </>
  )
})

export default AddDetails;

function isEmailValid(inputText) {
  let flag = true;
  let helperText = "";
  // eslint-disable-next-line
  var mailFormat =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  if (!inputText || inputText === "") {
    flag = false;
    helperText = "Please Enter email address.";
  } else if (!String(inputText).toLowerCase().match(mailFormat)) {
    flag = false;
    helperText = "Please Enter Valid Email Address.";
  }
  return { flag, helperText };
}

function isPasswordFieldValid(value) {
  var lowerCaseLetters = /[a-z]/g;
  var upperCaseLetters = /[A-Z]/g;
  var numbers = /[0-9]/g;
  var specialCharacters = /(?=.*[@#$%^&+=!*])/g;
  let flag = true;
  let helperText = "";
  if (value === "") {
    helperText = "Please Enter Password.";
    flag = false;
  }
  // Validate length
  else if (value.length <= 10) {
    helperText = "Password must be more than 10 letters!";
    flag = false;
  }
  // Validate capital letters
  else if (!value.match(upperCaseLetters)) {
    helperText = "Password must contain 1 Uppercase!";
    flag = false;
  } else if (!value.match(lowerCaseLetters)) {
    helperText = "Password must contain 1 Lowercase!";
    flag = false;
  }
  // Validate numbers
  else if (!value.match(numbers)) {
    helperText = "Password must contain 1 Number!";
    flag = false;
  } else if (!value.match(specialCharacters)) {
    helperText = "Password must contain 1 Special Character!";
    flag = false;
  } else {
    helperText = "";
    flag = true;
  }
  return { flag, helperText };
}

function isPhoneNumberValid(inputText) {
  inputText = inputText?.toString();
  let flag = true;
  let helperText = "";
  if (inputText.length !== 12) {
    flag = false;
    helperText = `Please Enter Valid Phone Number with country code.`;
  }
  return { flag, helperText };
}

function isRequiredFieldValid(inputText, fieldName, min, max) {
  if(inputText){
    inputText = inputText.toString();
  }
  let flag = true;
  let helperText = "";
  if (!inputText || inputText === "" ) {
    flag = false;
    helperText = `Please Enter ${fieldName}.`;
  } else if (min && inputText.length < min) {
    flag = false;
    helperText = `Please Enter at least ${min} words.`;
  } else if (max && inputText.length > max) {
    flag = false;
    helperText = `Please Enter less than ${max} words.`;
  }
  return { flag, helperText };
} 